import React, { useState, useEffect, useRef } from "react";
import { API_URL } from "../config";
import "./ChangePasswordModal.css";

export default function ChangePasswordModal({ onClose }) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const firstFieldRef = useRef(null);

  useEffect(() => {
    if (firstFieldRef.current) firstFieldRef.current.focus();
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("Rellena todos los campos");
      return;
    }
    if (newPassword.length < 4) {
      setError("La nueva contraseña debe tener al menos 4 caracteres");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("La nueva contraseña y su confirmación no coinciden");
      return;
    }
    if (newPassword === oldPassword) {
      setError("La nueva contraseña debe ser distinta de la actual");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/auth/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setSuccess(true);
        setTimeout(() => onClose(), 1500);
      } else {
        setError(data.detail || "No se ha podido cambiar la contraseña");
      }
    } catch {
      setError("No se puede conectar con el servidor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-modal-overlay" onClick={handleBackdropClick}>
      <div className="cp-modal" role="dialog" aria-modal="true" aria-labelledby="cp-title">
        <div className="cp-modal-header">
          <h2 id="cp-title">Cambiar contraseña</h2>
          <button className="cp-close" onClick={onClose} aria-label="Cerrar">×</button>
        </div>

        {success ? (
          <div className="cp-success">
            <div className="cp-success-icon">✓</div>
            <p>Contraseña actualizada correctamente</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="cp-form">
            <div className="cp-field">
              <label>Contraseña actual</label>
              <input
                ref={firstFieldRef}
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
            </div>
            <div className="cp-field">
              <label>Nueva contraseña</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                disabled={loading}
              />
              <small className="cp-hint">Mínimo 4 caracteres</small>
            </div>
            <div className="cp-field">
              <label>Confirmar nueva contraseña</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                disabled={loading}
              />
            </div>

            {error && <p className="cp-error">{error}</p>}

            <div className="cp-actions">
              <button type="button" className="cp-btn cp-btn--ghost" onClick={onClose} disabled={loading}>
                Cancelar
              </button>
              <button type="submit" className="cp-btn cp-btn--primary" disabled={loading}>
                {loading ? "Guardando..." : "Cambiar contraseña"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
